"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmUser = void 0;
var json2typescript_1 = require("json2typescript");
var JsonDateConverter_1 = require("../../utilities/JsonDateConverter");
var Address_1 = require("../Common/Address");
var CrmOrganization_1 = require("./CrmOrganization");
var CrmUser = /** @class */ (function () {
    function CrmUser() {
        this.emailAddress = "";
        this.firstName = "";
        this.lastName = "";
        this.title = "";
        this.identityId = "";
        this.configioId = "";
        this.accountingId = "";
        this.address = null;
        this.organization = null;
        this.createdOn = new Date();
        this.modifiedOn = new Date();
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)("emailAddress", String, false)
    ], CrmUser.prototype, "emailAddress", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("firstName", String, false)
    ], CrmUser.prototype, "firstName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("lastName", String, false)
    ], CrmUser.prototype, "lastName", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("title", String, true)
    ], CrmUser.prototype, "title", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("identityId", String, true)
    ], CrmUser.prototype, "identityId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("configioId", String, true)
    ], CrmUser.prototype, "configioId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("accountingId", String, true)
    ], CrmUser.prototype, "accountingId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("createdOn", JsonDateConverter_1.DateConverter, true)
    ], CrmUser.prototype, "createdOn", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("address", Address_1.Address, true)
    ], CrmUser.prototype, "address", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("organization", CrmOrganization_1.CrmOrganization, true)
    ], CrmUser.prototype, "organization", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)("modifiedOn", JsonDateConverter_1.DateConverter, true)
    ], CrmUser.prototype, "modifiedOn", void 0);
    CrmUser = __decorate([
        (0, json2typescript_1.JsonObject)("CrmUser")
    ], CrmUser);
    return CrmUser;
}());
exports.CrmUser = CrmUser;
